import React, { useState, useCallback } from "react";
import { Lightbox } from "react-modal-image";

import { ModalPortal } from "./modalroot";

type Options = {
  alt?: string;
};

export function useBasicLightBox(): [
  (imageUrl: string, options?: Options) => void,
  React.ReactNode
] {
  const [state, setState] = useState<{
    imageUrl: string;
    options?: Options;
  }>();

  const open = useCallback(
    (imageUrl: string, options?: Options) => {
      setState({
        imageUrl,
        options,
      });
    },
    [setState]
  );

  const close = useCallback(() => {
    setState(undefined);
  }, [setState]);

  return [
    open,
    state && (
      <ModalPortal>
        <Lightbox
          hideDownload
          large={state.imageUrl}
          alt={state.options?.alt}
          onClose={close}
        />
      </ModalPortal>
    ),
  ];
}
